import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import busActions from 'actions/bus.actions';
import userActions from 'actions/user.actions';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import _ from 'lodash';

//import avatar from "assets/img/faces/face-3.jpg";

class EditBus extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(busActions.getBus(this.props.match.params.id));
    this.state = {
      submitted: false,
      bus: {
        hasWifi: false,
        hasMovies: false,
        hasPowerOutlets: false,
        driverInput: '',
        type: '',
        name: '',
        company: '',
        capacity: '',
        driver: '',
        defaultPrice: '',
        defaultFirstSpecialSeats: '',
        defaultLastSpecialSeats: '',
        defaultFirstSpecialSeatsPrice: '',
        defaultLastSpecialSeatsPrice: ''
      },
      suggestions: [],
      seatPricingTiers: null, // null = using defaults, array = custom tiers
      tiersModified: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.driverSelected = this.driverSelected.bind(this);
    this.onDriversFetchRequested = this.onDriversFetchRequested.bind(this);
    this.onDriversClearRequested = this.onDriversClearRequested.bind(this);
    this.fetchDriversWithDebounce = _.debounce(this.onDriversFetchRequested, 1500);
  }

  getSelectableRows(busType) {
    if (busType === 'Elite') return 4;
    return 5;
  }

  getDefaultTiers(busType) {
    if (busType === 'Elite') {
      return [
        { name: 'Premium', rows: [1, 2], additionalPrice: 12, description: 'Front rows with extra legroom' },
        { name: 'Preferred', rows: [3, 4], additionalPrice: 10, description: 'Mid-front rows' }
      ];
    }
    return [
      { name: 'Premium', rows: [1, 2, 3], additionalPrice: 12, description: 'Front rows with extra legroom' },
      { name: 'Preferred', rows: [4, 5], additionalPrice: 10, description: 'Mid-front rows' }
    ];
  }

  getRowsUsedByOtherTiers(tiers, currentIndex) {
    const used = [];
    tiers.forEach((tier, i) => {
      if (i !== currentIndex && tier.rows) {
        used.push(...tier.rows);
      }
    });
    return used;
  }

  toggleRow(index, row) {
    const tiers = [...(this.state.seatPricingTiers || this.getDefaultTiers(this.state.bus.type))];
    const currentRows = [...(tiers[index].rows || [])];
    const rowIdx = currentRows.indexOf(row);
    if (rowIdx > -1) {
      currentRows.splice(rowIdx, 1);
    } else {
      currentRows.push(row);
      currentRows.sort((a, b) => a - b);
    }
    tiers[index] = { ...tiers[index], rows: currentRows };
    this.setState({ seatPricingTiers: tiers, tiersModified: true });
  }

  handleTierChange(index, field, value) {
    const tiers = [...(this.state.seatPricingTiers || this.getDefaultTiers(this.state.bus.type))];
    if (field === 'additionalPrice') {
      tiers[index] = { ...tiers[index], additionalPrice: parseFloat(value) || 0 };
    } else {
      tiers[index] = { ...tiers[index], [field]: value };
    }
    this.setState({ seatPricingTiers: tiers, tiersModified: true });
  }

  addTier() {
    const tiers = [...(this.state.seatPricingTiers || this.getDefaultTiers(this.state.bus.type))];
    tiers.push({ name: '', rows: [], additionalPrice: 0, description: '' });
    this.setState({ seatPricingTiers: tiers, tiersModified: true });
  }

  removeTier(index) {
    const tiers = [...(this.state.seatPricingTiers || this.getDefaultTiers(this.state.bus.type))];
    if (tiers.length === 1) {
      this.props.addNotification({
        type: 'warning',
        message: 'At least one tier is required. To make these seats free, set the Additional Price to $0. To go back to default pricing, use "Reset to Defaults".'
      });
      return;
    }
    tiers.splice(index, 1);
    this.setState({ seatPricingTiers: tiers, tiersModified: true });
  }

  resetTiersToDefaults() {
    this.setState({ seatPricingTiers: null, tiersModified: true });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let bus = this.state.bus;
    bus[name] = value;
    this.setState({ bus: bus });
  }

  driverSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    let bus = this.state.bus;
    bus.driver = suggestionValue;
    bus.driverInput = suggestion.firstName + " " + suggestion.lastName;
    this.setState({bus: bus});
  }

  onDriversFetchRequested = ({ value }) => {
    if(this.state.bus.driver && value) {
      if(_.find(this.state.suggestions, {id: this.state.bus.driver, firstName: value.split(" ")[0], lastName: value.split(" ")[1]})) {
        this.setState({suggestions: []});
        return;
      }
    }
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if(inputLength === 0) {
      this.setState({suggestions: []});
      return;
    }
    if(inputLength >= 3) {
      if(inputValue.indexOf(" ") > -1) {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue.split(" ")[0]}, {id: 'lastName', value: inputValue.split(" ")[1]}])}));
      }
      else {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue}])})); 
      }
    }
  };

  onDriversClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { dispatch } = this.props;
    // Validate tiers before submitting
    if (this.state.seatPricingTiers && this.state.tiersModified) {
      for (const tier of this.state.seatPricingTiers) {
        if (!tier.name || !tier.rows || tier.rows.length === 0) {
          return; // validation errors will show inline
        }
      }
    }

    if (this.state.bus.name && this.state.bus.company && this.state.bus.type && this.state.bus.capacity && this.state.bus.defaultPrice) {
      const payload = {
        hasWifi: this.state.bus.hasWifi,
        hasMovies: this.state.bus.hasMovies,
        hasPowerOutlets: this.state.bus.hasPowerOutlets,
        type: this.state.bus.type,
        name: this.state.bus.name,
        company: this.state.bus.company,
        capacity: this.state.bus.capacity,
        driver: this.state.bus.driver,
        defaultPrice: this.state.bus.defaultPrice,
        defaultFirstSpecialSeats: this.state.bus.defaultFirstSpecialSeats || null,
        defaultLastSpecialSeats: this.state.bus.defaultLastSpecialSeats || null,
        defaultFirstSpecialSeatsPrice: this.state.bus.defaultFirstSpecialSeatsPrice || null,
        defaultLastSpecialSeatsPrice: this.state.bus.defaultLastSpecialSeatsPrice || null
      };
      if (this.state.tiersModified) {
        payload.seat_pricing_tiers = this.state.seatPricingTiers;
      }
      dispatch(busActions.update(this.props.match.params.id, payload));
    }
  }

  componentWillUpdate(props) {
    if(props.bus && JSON.stringify(this.props.bus) !== JSON.stringify(props.bus)) {
      let bus = props.bus;
      bus.driverInput = props.bus.driver ? props.bus.driver.firstName + " " + props.bus.driver.lastName : '';
      bus.driver = props.bus.driver ? props.bus.driver.id : null;
      bus.defaultFirstSpecialSeats = props.bus.defaultFirstSpecialSeats || '';
      bus.defaultFirstSpecialSeatsPrice = props.bus.defaultFirstSpecialSeatsPrice || '';
      bus.defaultLastSpecialSeats = props.bus.defaultLastSpecialSeats || '';
      bus.defaultLastSpecialSeatsPrice = props.bus.defaultLastSpecialSeatsPrice || '';
      bus.hasWifi = bus.hasWifi || false;
      bus.hasMovies = bus.hasMovies || false;
      bus.hasPowerOutlets = bus.hasPowerOutlets || false;
      this.setState({
        bus: bus,
        seatPricingTiers: props.bus.seat_pricing_tiers || null
      });
    }
    if(props.error && !this.props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
    if(props.success && !this.props.success) {
      this.props.addNotification({type: 'success', message: 'Bus updated successfully'});
    }
    if(props.drivers && JSON.stringify(props.drivers) !== JSON.stringify(this.state.suggestions)) {
      this.setState({suggestions: props.drivers});
    }
  }

  handleCheckbox = event => {
    const target = event.target;
    let bus = this.state.bus;
    bus[target.name] = target.checked;
    this.setState({ bus: bus });
  };

  render() {
    const { submitted, bus, suggestions } = this.state;
    const { loading } = this.props;
    const getSuggestionValue = suggestion => suggestion.id;
    const renderSuggestion = suggestion => (
      <div>
        {suggestion.firstName + " " + suggestion.lastName}
      </div>
    );
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Edit Bus"
                content={
                  <form name="profileForm" onSubmit={this.handleSubmit}>
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Name",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Name",
                          value: bus.name,
                          name: 'name',
                          onChange: this.handleChange
                        },
                        {
                          label: "Company",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Company",
                          value: bus.company,
                          name: 'company',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={6}>{submitted && !bus.name && <div className="error">Name is required</div>}</Col>
                      <Col md={6}>{submitted && !bus.company && <div className="error">Company is required</div>}</Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Driver</ControlLabel>
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.fetchDriversWithDebounce}
                            onSuggestionsClearRequested={this.onDriversClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            onSuggestionSelected={this.driverSelected}
                            inputProps={{
                              name: 'driverInput',
                              value: bus.driverInput,
                              placeholder: 'Driver',
                              onChange: this.handleChange,
                              className: 'form-control'
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-4", "col-md-4", "col-md-4"]}
                      proprieties={[
                        {
                          label: "Type",
                          componentClass: "select",
                          bsClass: "form-control",
                          placeholder: "Type",
                          value: bus.type,
                          name: 'type',
                          options: [{label: 'AC'}, {label: 'Non-AC'}, {label: 'Express'}, {label: 'Elite'}],
                          onChange: this.handleChange
                        },
                        {
                          label: "Capacity",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Capacity",
                          value: bus.capacity,
                          name: 'capacity',
                          onChange: this.handleChange
                        },
                        {
                          label: "Default Price",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Default Price",
                          value: bus.defaultPrice,
                          name: 'defaultPrice',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={4}>{submitted && !bus.type && <div className="error">Type is required</div>}</Col>
                      <Col md={4}>{submitted && !bus.capacity && <div className="error">Capacity is required</div>}</Col>
                      <Col md={4}>{submitted && !bus.defaultPrice && <div className="error">Price is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Default First Special Seats",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Default First Special Seats",
                          value: bus.defaultFirstSpecialSeats,
                          name: 'defaultFirstSpecialSeats',
                          onChange: this.handleChange
                        },
                        {
                          label: "Default First Special Seats Price",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Default First Special Seats Price",
                          value: bus.defaultFirstSpecialSeatsPrice,
                          name: 'defaultFirstSpecialSeatsPrice',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Default Last Special Seats",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Default Last Special Seats",
                          value: bus.defaultLastSpecialSeats,
                          name: 'defaultLastSpecialSeats',
                          onChange: this.handleChange
                        },
                        {
                          label: "Default Last Special Seats Price",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Default Last Special Seats Price",
                          value: bus.defaultLastSpecialSeatsPrice,
                          name: 'defaultLastSpecialSeatsPrice',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row>
                      <Col md={12}>
                        <h4 style={{marginTop: 20, marginBottom: 10}}>Seat Pricing Tiers</h4>
                        {this.state.seatPricingTiers === null && (
                          <p style={{color: '#999', marginBottom: 10}}>
                            Using default pricing. Click "Customize Tiers" to override.
                          </p>
                        )}
                        {(this.state.seatPricingTiers || this.getDefaultTiers(bus.type)).map((tier, index) => (
                          <Row key={index} style={{marginBottom: 10, padding: '10px', background: this.state.seatPricingTiers === null ? '#f9f9f9' : '#fff', border: '1px solid #eee', borderRadius: 4}}>
                            <Col md={3}>
                              <FormGroup>
                                <ControlLabel>Tier Name</ControlLabel>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={tier.name}
                                  disabled={this.state.seatPricingTiers === null}
                                  onChange={(e) => this.handleTierChange(index, 'name', e.target.value)}
                                />
                                {this.state.submitted && this.state.seatPricingTiers !== null && !tier.name && (
                                  <div className="error" style={{color: '#e74c3c', fontSize: 12, marginTop: 4}}>Tier name is required</div>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <ControlLabel>Rows</ControlLabel>
                                <div style={{display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4}}>
                                  {Array.from({length: this.getSelectableRows(bus.type)}, (_, i) => i + 1).map(row => {
                                    const tiers = this.state.seatPricingTiers || this.getDefaultTiers(bus.type);
                                    const isSelected = tier.rows && tier.rows.includes(row);
                                    const usedByOther = this.getRowsUsedByOtherTiers(tiers, index).includes(row);
                                    const disabled = this.state.seatPricingTiers === null || usedByOther;
                                    return (
                                      <span
                                        key={row}
                                        onClick={() => !disabled && this.toggleRow(index, row)}
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: 32,
                                          height: 28,
                                          borderRadius: 4,
                                          fontSize: 13,
                                          fontWeight: isSelected ? 600 : 400,
                                          cursor: disabled ? 'not-allowed' : 'pointer',
                                          border: isSelected ? '2px solid #1DC7EA' : '1px solid #ccc',
                                          background: isSelected ? '#E8F8FC' : usedByOther ? '#f0f0f0' : '#fff',
                                          color: usedByOther ? '#aaa' : isSelected ? '#1DC7EA' : '#333',
                                          userSelect: 'none'
                                        }}
                                        title={usedByOther ? 'Assigned to another tier' : `Row ${row}`}
                                      >
                                        {row}
                                      </span>
                                    );
                                  })}
                                </div>
                                {this.state.submitted && this.state.seatPricingTiers !== null && (!tier.rows || tier.rows.length === 0) && (
                                  <div className="error" style={{color: '#e74c3c', fontSize: 12, marginTop: 4}}>Please select at least one row for this tier</div>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md={2}>
                              <FormGroup>
                                <ControlLabel>Additional Price ($)</ControlLabel>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={tier.additionalPrice || ''}
                                  placeholder="0"
                                  min="0"
                                  step="0.01"
                                  disabled={this.state.seatPricingTiers === null}
                                  onChange={(e) => this.handleTierChange(index, 'additionalPrice', e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <ControlLabel>Description</ControlLabel>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={tier.description || ''}
                                  disabled={this.state.seatPricingTiers === null}
                                  onChange={(e) => this.handleTierChange(index, 'description', e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={1}>
                              {this.state.seatPricingTiers !== null && (
                                <Button bsStyle="danger" simple style={{marginTop: 25}} onClick={() => this.removeTier(index)}>
                                  <i className="fa fa-times"></i>
                                </Button>
                              )}
                            </Col>
                          </Row>
                        ))}
                        <div style={{marginTop: 10}}>
                          {this.state.seatPricingTiers === null ? (
                            <Button bsStyle="info" fill onClick={() => this.setState({ seatPricingTiers: this.getDefaultTiers(bus.type), tiersModified: true })}>
                              Customize Tiers
                            </Button>
                          ) : (
                            <>
                              <Button bsStyle="info" fill onClick={() => this.addTier()} style={{marginRight: 10}}>
                                Add Tier
                              </Button>
                              <Button bsStyle="default" fill onClick={() => this.resetTiersToDefaults()}>
                                Reset to Defaults
                              </Button>
                            </>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Checkbox
                          number='hasWifi'
                          name='hasWifi'
                          value={bus.hasWifi}
                          onChange={this.handleCheckbox.bind(this)}
                          checked={bus.hasWifi}
                          label='Wifi'
                        />
                      </Col>
                      <Col md={4}>
                        <Checkbox
                          number='hasMovies'
                          name='hasMovies'
                          value={bus.hasMovies}
                          onChange={this.handleCheckbox.bind(this)}
                          checked={bus.hasMovies}
                          label='Movies'
                        />
                      </Col>
                      <Col md={4}>
                        <Checkbox
                          number='hasPowerOutlets'
                          name='hasPowerOutlets'
                          value={bus.hasPowerOutlets}
                          onChange={this.handleCheckbox.bind(this)}
                          checked={bus.hasPowerOutlets}
                          label='Power Outlets'
                        />
                      </Col>
                    </Row>
                    <Button bsStyle="info" disabled={loading} fill type="submit">
                      Update Bus
                    </Button>
                    {loading && submitted && 
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loading, item, error, success } = state.buses;
  const { items } = state.users;
  return {
    loading, bus: item, error, success, drivers: items
  };
}
 
export default connect(mapStateToProps)(EditBus);
